import {useControlledState as $lIBue$useControlledState} from "@react-stately/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5ff2beda28820a2f$exports = {};

$parcel$export($5ff2beda28820a2f$exports, "useToggleState", () => $5ff2beda28820a2f$export$8042c6c013fd5226);

function $5ff2beda28820a2f$export$8042c6c013fd5226(props = {
}) {
    let { isReadOnly: isReadOnly  } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = $lIBue$useControlledState(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}




export {$5ff2beda28820a2f$export$8042c6c013fd5226 as useToggleState};
//# sourceMappingURL=module.js.map
